<script lang="ts">
	import type { ImageProps, InlineIconTextProps } from '@app/components/cms/types';
	import { storyblokEditable } from '@storyblok/svelte';
	import InlineIconText from '@app/components/cms/InlineIconText.svelte';
	import { getOptimizedCmsImageUrl } from '@app/utils/cms';
	import LandingPageSectionTitles from '@app/components/cms/landing-pages/LandingPageSectionTitles.svelte';

	export let blok: {
		title: string;
		desc: string;
		img: ImageProps;
		list: [InlineIconTextProps];
	};
</script>

<div use:storyblokEditable={blok} class="pb-[64px] lg:pb-[80px]">
	<div class="container">
		<div class="space-y-4">
			<LandingPageSectionTitles {blok} />
			<div class="pt-5 grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-7 items-center">
				<div class="flex justify-center">
					<svg class="" viewBox="0 0 298 273" fill="none" xmlns="http://www.w3.org/2000/svg">
						<clipPath id="svgPath">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M103 0H194V273H103V0ZM0 65H91V252H0V65ZM298 26H207V242H298V26Z"
								fill="#D9D9D9"
							/>
						</clipPath>
						<image
							href={getOptimizedCmsImageUrl(blok.img.filename, '1000x0')}
							width="100%"
							height="100%"
							class="masked-image"
							preserveAspectRatio="xMinYMin slice"
						/>
					</svg>
				</div>
				<div class="space-y-4">
					{#each blok.list as item}
						<InlineIconText props={item} />
					{/each}
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="postcss">
	.masked-image {
		clip-path: url(#svgPath);
	}
</style>
